import { render, staticRenderFns } from "./MobilePageFooter.vue?vue&type=template&id=4cb176d9&lang=pug"
import script from "./MobilePageFooter.vue?vue&type=script&lang=js"
export * from "./MobilePageFooter.vue?vue&type=script&lang=js"
import style0 from "./MobilePageFooter.vue?vue&type=style&index=0&id=4cb176d9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports